module.exports = __webpack_public_path__ + "components/rewards/twelve-day/static/logo-2e9671f82bc3a69f41e321d8685ce888.jpg";